import React, { useEffect, useState } from 'react';
import { ModalView } from '../../../providers/modal.provider';
import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import { TranslationCreateLocale, TranslationUpdateTranslationLocale } from './services';
import { toast } from 'react-toastify';

const TranslationPluginLanguagesModal = ({
  language,
  isOpen,
  onCloseEvent,
  refreshEvent,
}) => {
  const [form, setForm] = useState({ ...(language || {}) });
  const handleSave = async () => {
    try {
      if (form?.id) {
        const r = await TranslationUpdateTranslationLocale(form);
        refreshEvent();
      } else {
        const dataObj = {
          ...form,
          sortOrder: parseInt(form.sortOrder, 10) || 1,
          isDefault: form.isDefault || false,
          status: form.status || 'inactive',
        };
        const r = await TranslationCreateLocale(dataObj);
        refreshEvent();
      }
    } catch (error) {
      console.log(error);
      toast.error(
        'Error saving language: ' + (error?.response?.data?.message || error.message)
      );
    }
  };

  useEffect(() => {
    if (language) {
      setForm({
        ...language,
      });
    } else {
      setForm({});
    }
  }, [language]);

  return (
    <ModalView fader={isOpen === true ? 'show' : 'hide'} onCloseEvent={onCloseEvent}>
      <Box sx={{ mt: 4, p: 3 }} className='col-count-2 gap-3 col-c1-md'>
        <TextField
          label='Locale Code'
          fullWidth
          value={form?.localeCode || ''}
          onChange={(e) =>
            setForm({
              ...form,
              localeCode: e.target.value
                .replace(/[^A-Z\s]/gi, '')
                .toLocaleLowerCase()
                .substring(0, 2),
            })
          }
          margin='normal'
        />
        <TextField
          label='Locale Name'
          className='span-2 span-1-md'
          fullWidth
          value={form?.localeName || ''}
          onChange={(e) => setForm({ ...form, localeName: e.target.value })}
          margin='normal'
        />

        <TextField
          label='Sort Order'
          fullWidth
          value={form?.sortOrder || '1'}
          onChange={(e) => setForm({ ...form, sortOrder: e.target.value })}
          margin='normal'
        />

        <Box className='start-1 span-2 span-1-md'>
          <InputLabel>Status</InputLabel>
          <Select
            value={form?.status || 'active'}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
            fullWidth
          >
            <MenuItem value=''>Select</MenuItem>
            <MenuItem value='active'>Active</MenuItem>
            <MenuItem value='inactive'>Inactive</MenuItem>
          </Select>
        </Box>
        <Stack direction='row' alignItems='center' gap={1} sx={{ mt: 2, mb: 2 }}>
          <InputLabel>Set as Default Language?</InputLabel>
          <Switch
            checked={form?.isDefault || false}
            onChange={(e) => setForm({ ...form, isDefault: e.target.checked })}
          />
        </Stack>
        <Stack direction='row' gap={1} sx={{ mt: 2 }}>
          <Button variant='contained' onClick={handleSave}>
            Save
          </Button>
          <Button variant='outlined' onClick={onCloseEvent}>
            Cancel
          </Button>
        </Stack>
      </Box>
    </ModalView>
  );
};

TranslationPluginLanguagesModal.propTypes = {
  language: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sortOrder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    localeCode: PropTypes.string,
    localeName: PropTypes.string,
    isDefault: PropTypes.bool,
    status: PropTypes.string,
  }),
  isOpen: PropTypes.bool.isRequired,
  onCloseEvent: PropTypes.func.isRequired,
  refreshEvent: PropTypes.func.isRequired,
};

export default TranslationPluginLanguagesModal;
